<template>
  <v-card-text class="pa-0">
    <TituloPagina :titulo="tituloDaPagina" />
    <v-card-text
      class="pa-0 mt-3 primary--text"
      data-cy="texto_da_pagina"
      v-html="textoDaPagina"
    />
    <v-row
      no-gutters
      class="flex-column"
    >
      <v-col class="mb-1">
        <v-form
          ref="form"
        >
          <v-checkbox
            v-model="privacidade"
            class="my-2"
            color="grey darken-1"
            data-cy="chbox-termos-privacidade"
            :rules="[v => !!v || messages[0]]"
            @change="validarForm()"
          >
            <template v-slot:label>
              <div
                class="caption my-n2 ml-2 grey--text text--darken-1"
              >
                Li, aceito e estou ciente dos
                <a
                  href="https://monetizze.com.br/termos#privacy"
                  target="_blank"
                  class="text-decoration-underline grey--text text--darken-2"
                  data-cy="termo_responsabilidade"
                  @click.stop
                >
                  <strong>
                    Termos de Responsabilidade e Privacidade
                  </strong>
                </a>
              </div>
            </template>
          </v-checkbox>
          <v-checkbox
            v-model="compartilhamento"
            class="my-2"
            color="grey darken-1"
            data-cy="chbox-termos-dados"
            :rules="[v => !!v || messages[1]]"
            @change="validarForm()"
          >
            <template v-slot:label>
              <div
                class="caption my-n2 ml-2 grey--text text--darken-1"
              >
                Li, aceito e estou ciente do
                <a
                  href="https://monetizze.com.br/termos#privacy"
                  target="_blank"
                  class="text-decoration-underline grey--text text--darken-2"
                  data-cy="termo_compartilhamento"
                  @click.stop
                >
                  <strong>
                    Termo de Compartilhamento de dados e informações
                  </strong>
                </a>
              </div>
            </template>
          </v-checkbox>
        </v-form>
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>

import TituloPagina from '@/components/TituloPagina.vue';

export default {
  name: 'PassoFaltaPouco',

  components: {
    TituloPagina,
  },

  data() {
    return {
      privacidade: '',
      compartilhamento: '',
      tituloDaPagina: 'Falta pouco',
      textoDaPagina: '<p>Obs. 1: Alertamos que a indicação de dados inexistentes ou incorretos poderá impossibilitar o reembolso e não poderá ser corrigido. Por isso, tenha atenção e confira mais de uma vez.</p><p>Obs. 2: Para fins de reembolso, é necessária a coleta do Nome completo, CPF e dos dados bancários do titular.</p>',
      messages: [
        'Você deve ler e concordar com os Termos de Responsabilidade e Privacidade para continuar.',
        'Você deve ler e concordar com o Termo de Compartilhamento de dados e informações para continuar.',
      ],
    };
  },

  methods: {
    validarForm() {
      if (this.privacidade !== '' && this.compartilhamento !== '') {
        this.$emit('formValidado', {
          validado: this.$refs.form.validate(),
          form: {
            accepted_terms: this.$refs.form.validate(),
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
  .text-decoration-underline { text-decoration: underline; }
</style>
